// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-default/index.css'
import './assets/css.css'
// import 'whatwg-fetch'
import axios from 'axios'
import App from './App'
import router from './router'
import store from './store/store.js'
import Lib from './lib/lib'

Vue.prototype.$http = axios
Vue.config.productionTip = true
function formatComponentName(vm) {
  if (vm.$root === vm) return 'root';

  var name = vm._isVue ? vm.$options.name || vm.$options._componentTag : vm.name;
  return (name ? 'component <' + name + '>' : 'anonymous component') + (vm._isVue && vm.$options.__file ? ' at ' + vm.$options.__file : '');

}




//ui框架和状态管理
Vue.use(ElementUI)
Vue.use(Vuex)


new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})
/**
 * For the brave souls who get this far: You are the chosen ones,
 * the valiant knights of programming who toil away, without rest,
 * fixing our most awful code. To you, true saviors, kings of men,
 * I say this: never gonna give you up, never gonna let you down,
 * never gonna run around and desert you. Never gonna make you cry,
 * never gonna say goodbye. Never gonna tell a lie and hurt you.
 */



// WEBPACK FOOTER //
// ./src/main.js